import moment from 'moment';
import { store } from '../../source/index';

const getOrgDateFormat = () => {
  const OrgSettings = store.getState()?.app?.organisation_settings;
  return OrgSettings?.date_format || 'DD/MM/YYYY';
};

const normalizeIssueHistoryEventType = (event) => {
  const rawType = String(
    event?.type ?? event?.Type ?? event?.eventType ?? event?.action ?? ''
  )
    .trim()
    .toLowerCase();
  const typeAliases = {
    issue: 'issued',
    issued: 'issued',
    return: 'returned',
    returned: 'returned',
    sell: 'sold',
    sold: 'sold',
  };

  return typeAliases[rawType] || 'issued';
};

export const formatIssueHistoryEventWhen = (event) => {
  const raw =
    event?.datetime ?? event?.dateTime ?? event?.DateTime ?? event?.at ?? null;

  if (raw) {
    const parsed = moment(raw);
    if (parsed.isValid()) {
      const local = parsed.local();
      const date = local.format(getOrgDateFormat());
      const time = local.format('h:mm:ss A');
      return `${date} · ${time}`;
    }
  }

  const date = String(event?.date ?? '').trim();
  const time = String(event?.time ?? '').trim();
  return [date, time].filter(Boolean).join(' · ');
};

export const buildIssueHistoryLookup = (changes = []) => {
  const byRowId = new Map();
  const byStockId = new Map();

  (changes || []).forEach((entry) => {
    const events = (entry?.events || [])
      .filter((event) => event?.type && Number(event?.qty) > 0)
      .map((event) => ({
        ...event,
        type: normalizeIssueHistoryEventType(event),
      }));
    if (!events.length) {
      return;
    }

    const normalized = {
      rowId: String(entry?.rowId ?? entry?.id ?? ''),
      stockId: String(entry?.stockId ?? ''),
      SKU: String(entry?.SKU ?? entry?.sku ?? '-'),
      events,
    };

    if (normalized.rowId) {
      byRowId.set(normalized.rowId, normalized);
    }
    if (normalized.stockId) {
      byStockId.set(normalized.stockId, normalized);
    }
  });

  return { byRowId, byStockId };
};

export const getIssueHistoryForRow = (row, lookup) => {
  if (!row || !lookup) {
    return null;
  }

  const rowId = String(
    row?.po_product_id ?? row?.id ?? row?.product_id ?? ''
  );
  const stockId = String(row?.stock_id ?? '');

  if (rowId && lookup.byRowId?.has(rowId)) {
    return lookup.byRowId.get(rowId);
  }
  if (stockId && lookup.byStockId?.has(stockId)) {
    return lookup.byStockId.get(stockId);
  }

  return null;
};

export const getIssueHistoryEventParts = (event, t) => {
  const type = normalizeIssueHistoryEventType(event);
  const typeLabels = {
    issued: 'Issued',
    returned: 'Returned',
    sold: 'Sold',
  };
  const typeLabel = typeLabels[type];
  const qty = Number.parseInt(String(event?.qty ?? 0), 10) || 0;
  const when = formatIssueHistoryEventWhen(event);

  return { type, typeLabel, qty, when };
};

export const formatIssueHistoryEventLine = (event, t) => {
  const { typeLabel, qty, when } = getIssueHistoryEventParts(event, t);

  return when
    ? `${typeLabel} ${qty} · ${when}`
    : `${typeLabel} ${qty}`;
};
